import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GridsterModule } from 'angular-gridster2';
import { ReactiveFormsModule } from '@angular/forms';

import { DashboardComponent } from './dashboard/components/dashboard.component';
import { TileComponent } from './dashboard/components/tile.component';

import { DashboardTilesRegistry } from './dashboard/services/DashboardTilesRegistry';
import { ConnectFormDirective } from './common/directives/connect-form.directive';
import { FormControlAutoSaveComponent } from './workspace/components/form-control-auto-save.component';
import { AutoSaveFormBuilder } from './workspace/AutoSaveFormBuilder';
import { SearchComponent } from './search/components/search.component';
import { AlertsComponent } from './alerts/components/alerts.component';
import { TileNavigationDirective } from './dashboard/directives/tile-navigation.directive';
import { ConfirmationDialogComponent } from './common/components/confirmation-dialog.component';
import { ConfirmationDialogDirective } from './common/directives/confirmation-dialog.directive';
import { ActionLoadingComponent } from './common/components/action-loading.component';
import { MarqueeTextBoxComponent } from './common/components/marquee-text-box.component';
import { MetadataFormControlComponent } from './workspace/components/metadata-form-control/metadata-form-control.component';
import { MetadataTemplateManagerService } from './workspace/services/metadata-template-manager.service';
import { MetadataTemplateRefDirective } from './workspace/directives/metadata-template-ref.directive';
import { MetadataWorkspaceComponent } from './workspace/components/metadata-workspace/metadata-workspace.component';
import { MetadataEntityListComponent } from './workspace/components/metadata-entity-list/metadata-entity-list.component';
import { ResponsiveGridDirective } from './dashboard/directives/responsive-grid.directive';
import { ResponsiveGridTileDirective } from './dashboard/directives/responsive-grid-tile.directive';
import { AllErrorsDirective } from "./workspace/directives/all-errors.directive";
import { SelectAllDirective } from './common/directives/select-all.directive';
import { RuleViolationDetailsComponent } from './workspace/components/rule-violation-details/rule-violation-details.component';
import { TextClick } from './common/directives/text-click.directive';
import { CoreModule } from '../core/core.module';
import { IfFormStatusDirective } from './common/directives/if-form-status.directive';
import { FormValuePipe } from './common/pipes/form-value.pipe';
import { FormStatusPipe } from './common/pipes/form-status.pipe';
import { FormChangesPipe } from './common/pipes/form-changes.pipe';
import { ClearInvalidValuesDirective } from './common/directives/clear-invalid-values-directive';
import { LayoutComponent } from './layout/layout.component';
import { RouteHistoryService } from './layout/route-history.service';
import { LayoutModule } from './layout/layout.module';

@NgModule({
  entryComponents: [ConfirmationDialogComponent],
    declarations: [DashboardComponent, TileComponent, ConnectFormDirective, FormControlAutoSaveComponent, SearchComponent, AlertsComponent, TileNavigationDirective, ConfirmationDialogComponent, ConfirmationDialogDirective, ActionLoadingComponent, MarqueeTextBoxComponent, MetadataFormControlComponent, MetadataTemplateRefDirective, MetadataWorkspaceComponent, MetadataEntityListComponent, ResponsiveGridDirective, ResponsiveGridTileDirective, AllErrorsDirective, SelectAllDirective, RuleViolationDetailsComponent, TextClick, IfFormStatusDirective, FormValuePipe, FormStatusPipe, FormChangesPipe, ClearInvalidValuesDirective, LayoutComponent],
  imports: [
    CommonModule,
    CoreModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature('pillar', {}),
    EffectsModule.forFeature([]),
    GridsterModule,
    ReactiveFormsModule,
    LayoutModule
  ],
    exports: [DashboardComponent, TileComponent, ConnectFormDirective, FormControlAutoSaveComponent, SearchComponent, AlertsComponent, TileNavigationDirective, ConfirmationDialogDirective, ActionLoadingComponent, MarqueeTextBoxComponent, MetadataFormControlComponent, MetadataTemplateRefDirective, MetadataWorkspaceComponent, MetadataEntityListComponent, ResponsiveGridDirective, ResponsiveGridTileDirective, AllErrorsDirective, SelectAllDirective, TextClick, ClearInvalidValuesDirective, LayoutComponent],
  providers: [DashboardTilesRegistry, AutoSaveFormBuilder, MetadataTemplateManagerService, RouteHistoryService]
})
export class PillarModule {}



// WEBPACK FOOTER //
// ./src/app/pillar/pillar.module.ts